import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";
import config from "./config";

export const PipelinesLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListPipelines} redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action={rbacActions.CreatePipeline} redirectTo={config.basePath}>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetPipeline} redirectTo={config.basePath}>
                        <EditPage/>
                    </RequirePermission>
                }

            >
            </Route>


        </Routes>
    );
};
